import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=28cf527c&scoped=true"
import script from "./DynamicList.vue?vue&type=script&lang=js"
export * from "./DynamicList.vue?vue&type=script&lang=js"
import style0 from "./DynamicList.vue?vue&type=style&index=0&id=28cf527c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf527c",
  null
  
)

export default component.exports